<template>
  <v-form ref="form">
    <v-row>
      <!-- RUT -->
      <v-col cols="12" md="6">
        <LabelComponent :text="docTypeDescription" />
        <v-chip
          label
          outlined
          large
          color="primary"
          style="width: 100%; height: 56px"
        >
          <v-icon left> mdi-format-horizontal-align-right </v-icon>
          {{ docNumber }}
        </v-chip>
      </v-col>

      <!-- RAZON SOCIAL -->
      <v-col cols="12" md="6">
        <LabelComponent text="Razón Social*" />
        <v-text-field
          outlined
          v-model="form.razon_social"
          :rules="[rules.required]"
          name="editCompanySocialReazon"
        >
        </v-text-field>
      </v-col>

      <!-- NOMBRE REPRESENTANTE LEGAL -->
      <v-col cols="12" md="6">
        <LabelComponent text="Nombre representante legal*" />
        <v-text-field
          outlined
          v-model="form.representante_legal_nombre"
          :rules="[rules.required]"
          name="editCompanyLegalRepresentative"
        >
        </v-text-field>
      </v-col>

      <!-- PRIMER APELLIDO REPRESENTANTE LEGAL -->
      <v-col cols="12" md="6">
        <LabelComponent text="Primer apellido representante legal*" />
        <v-text-field
          outlined
          v-model="form.representante_legal_primer_apellido"
          :rules="[rules.required]"
          name="editCompanyLegalRepresentative"
        >
        </v-text-field>
      </v-col>

      <!-- SEGUNDO APELLIDO REPRESENTANTE LEGAL -->
      <v-col cols="12" md="6">
        <LabelComponent text="Segundo apellido representante legal" />
        <v-text-field
          outlined
          v-model="form.representante_legal_segundo_apellido"
          name="editCompanyLegalRepresentative"
        >
        </v-text-field>
      </v-col>

      <!-- NACIONALIDAD SOCIEDAD V1 -->
      <!-- <v-col cols="12" md="6">
        <LabelComponent text="Nacionalidad de la Sociedad*" />
        <v-select
          :items="tipoNacionalidad"
          v-model="form.nacionalidad_sociedad"
          outlined
          item-text="descripcion"
          item-value="valor"
          :rules="[rules.required]"
          return-object
          name="editCompanyLegalRepresentative"
        >
        </v-select>
      </v-col> -->

      <!-- ES EXTRANJERO (NACIONALIDAD SOCIEDAD) V2 -->
      <v-col cols="12" md="6" class="d-flex align-center">
        <!-- <LabelComponent text="¿Es extranjero?*" /> -->
        <v-checkbox
          label="¿Es extranjero?*"
          v-model="form.es_extranjero"
          :true-value="true"
          :false-value="false"
          name="editCompanyIsForeign"
        ></v-checkbox>
      </v-col>

      <!-- GIRO V1 -->
      <!-- <v-col cols="12" md="6">
        <LabelComponent text="Giro*" />
        <v-text-field
          outlined
          v-model="form.giro"
          :rules="[rules.required]"
          name="editCompanySocialReazon"
        >
        </v-text-field>
      </v-col> -->

      <!-- GIRO V2 -->
      <v-col cols="12" md="6">
        <LabelComponent text="Giro*" />
        <v-autocomplete
          outlined
          v-model="form.giro_sector_comercial_id"
          :items="giros"
          item-text="nombre"
          item-value="_id"
          return-object
          :rules="[rules.required]"
          name="editCompanyGiro"
          @change="getActividadesComerciales"
        >
        </v-autocomplete>
      </v-col>

      <!-- ACTIVIDAD COMERCIAL V1 -->
      <!-- <v-col cols="12" md="6">
        <LabelComponent text="Actividad comercial*" />
        <v-text-field
          outlined
          v-model="form.actividad_comercial"
          :rules="[rules.required]"
          name="editCompanySocialReazon"
        >
        </v-text-field>
      </v-col> -->

      <!-- ACTIVIDAD COMERCIAL V2 -->
      <v-col cols="12" md="6">
        <LabelComponent text="Actividad comercial*" />
        <v-autocomplete
          outlined
          v-model="form.actividad_comercial_id"
          :items="actividadesComerciales"
          item-text="nombre"
          item-value="_id"
          return-object
          :rules="[rules.required]"
          :disabled="!form.giro_sector_comercial_id"
          :loading="loadingActividadesComerciales"
          name="editCompanyActividadComercial"
        >
        </v-autocomplete>
      </v-col>

      <!-- TELEFONO -->
      <v-col cols="12" md="6">
        <LabelComponent text="Teléfono*" />
        <TextFieldPhone
          :text="form.telefono"
          @input="form.telefono = $event"
          :rules="[rules.required]"
          name="editUserTelefono"
        />
      </v-col>

      <!-- EMAIL -->
      <v-col cols="12" md="6">
        <LabelComponent text="Correo electrónico*" />
        <v-text-field
          v-model="form.email"
          outlined
          name="editUserEmail"
          :rules="[rules.required, rules.email]"
        ></v-text-field>
      </v-col>

      <!-- FECHA -->
      <v-col cols="12" md="6">
        <LabelComponent text="Fecha Constitución*" />
        <v-text-field
          v-model="form.fecha_nacimiento"
          :rules="[rules.required, rules.date]"
          placeholder="dd/mm/yyyy"
          v-mask="dateMask"
          outlined
          name="editUserBirthDate"
        ></v-text-field>
      </v-col>

      <!-- DEPARTAMENTO -->
      <v-col cols="12" md="6">
        <LabelComponent text="Departamento" />
        <v-autocomplete
          v-model="form.region"
          :items="locations.regiones"
          @change="(form.provincia = null), (form.comuna = null)"
          return-object
          item-text="label"
          :rules="[rules.required]"
          outlined
        >
        </v-autocomplete>
      </v-col>

      <!-- PROVINCIA -->
      <v-col cols="12" md="6">
        <LabelComponent text="Provincia" />
        <v-autocomplete
          v-model="form.provincia"
          :items="
            locations.provincias.filter((e) => e.region == form.region?.value)
          "
          item-text="label"
          :disabled="!form.region"
          return-object
          @change="form.comuna = null"
          :rules="[rules.required]"
          outlined
        >
        </v-autocomplete>
      </v-col>

      <!-- COMUNA -->
      <v-col cols="12" md="6">
        <LabelComponent text="Distrito" />
        <v-autocomplete
          v-model="form.comuna"
          :items="
            locations.comunas.filter(
              (e) => e.provincia == form.provincia?.value
            )
          "
          item-text="label"
          return-object
          :disabled="!form.provincia"
          :rules="[rules.required]"
          outlined
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <slot name="policies-slot" />
  </v-form>
</template>

<script>
import TextFieldPhone from "@/components/Inputs/TextFieldPhone";
import LabelComponent from "@/components/Inputs/Label.vue";
import { validarEmail, validarFecha } from "@/store/resources/validate.js";
import { genreList } from "@/store/resources/constants.js";
import { dateMask } from "@/helpers/mask.js";
import { mapActions } from "vuex";

export default {
  name: "ClientPeruDNIForm",
  props: {
    docNumber: {
      type: [String, Number],
      default: "",
      required: true,
    },
    docType: {
      type: String,
      default: "",
    },
    docTypeDescription: {
      type: String,
      default: "",
    },
  },
  components: {
    TextFieldPhone,
    LabelComponent,
  },
  data: () => ({
    form: {
      razon_social: "",
      fecha_nacimiento: "",
      giro: "",
      representante_legal_nombre: "",
      representante_legal_primer_apellido: "",
      representante_legal_segundo_apellido: "",
      giro_sector_comercial_id: "",
      actividad_comercial: "",
      actividad_comercial_id: "",
      telefono: "",
      email: "",
      region: null,
      provincia: null,
      comuna: null,
      isPeru: true,
      es_extranjero: false,
    },
    giros: null,
    actividadesComerciales: null,
    tipoNacionalidad: null,
    loadingActividadesComerciales: false,
    rules: {
      required: (value) => !!value || "Este campo es requerido.",
      email: (value) => validarEmail(value) || "Correo invalido.",
      date: (value) =>
        validarFecha(value) || "El formato de la fecha es incorrecto",
    },
  }),
  created() {
    this.setup();
  },
  computed: {
    genreList: () => genreList,
    dateMask: () => dateMask,
    tipoPersona() {
      return "JUR";
    },
    locations() {
      const { regiones, provincias, comunas } = this.$store.getters.getLocation;
      return { regiones, provincias, comunas };
    },
  },
  methods: {
    ...mapActions("Users", [
      "getGiro",
      "getActividadComercial",
      "getNacionalidadSociedad",
    ]),

    setup() {
      this.getGiroList();
      this.getNacionalidadList();
    },

    async getGiroList() {
      const payload = { countryCode: "PE" };
      await this.getGiro(payload).then((res) => {
        this.giros = res;
      });
    },

    async getNacionalidadList() {
      await this.getNacionalidadSociedad().then((res) => {
        this.tipoNacionalidad = res;
      });
    },

    async getActividadesComerciales(data) {
      this.loadingActividadesComerciales = true;
      const payload = { countryCode: "PE", giroId: data._id };
      await this.getActividadComercial(payload)
        .then((res) => {
          this.actividadesComerciales = res;
        })
        .finally(() => {
          this.loadingActividadesComerciales = false;
        });
    },

    async setFormData(data) {
      // Se establece la informacion previa del cliente
      this.form.nombre = data?.nombre ?? "";
      //this.form.giro = data?.giro ?? "";
      this.form.razon_social = data?.razon_social ?? "";
      //this.form.actividad_comercial = data?.actividad_comercial ?? "";
      this.form.telefono = data?.datos_contacto?.telefono ?? "";
      this.form.email = data?.datos_contacto?.email || "";
      this.form.fecha_nacimiento = data?.fecha_nacimiento || "";
      // Establecer datos de territorio
      this.form.region =
        this.locations.regiones.find((e) => e.value === data?.region) ?? null;
      this.form.provincia =
        this.locations.provincias.find((e) => e.value === data?.provincia) ??
        null;
      this.form.comuna =
        this.locations.comunas.find((e) => e.value === data?.comuna) ?? null;
      this.form.apoderado_legal = data?.apoderado_legal ?? "";
      this.form.representante_legal_nombre =
        data?.representante_legal?.nombre ?? "";
      this.form.representante_legal_primer_apellido =
        data?.representante_legal?.primer_apellido ?? "";
      this.form.representante_legal_segundo_apellido =
        data?.representante_legal?.segundo_apellido ?? "";
      this.form.es_extranjero = data?.es_extranjero ?? false;
      this.form.giro_sector_comercial_id = data?.giro_sector_comercial_id ?? "";
      this.form.giro = data?.giro ?? "";
      await this.getActividadesComerciales({
        _id: this.form.giro_sector_comercial_id,
      });
      this.form.actividad_comercial_id = data?.actividad_comercial_id ?? "";
      this.form.actividad_comercial = data?.actividad_comercial ?? "";
      this.setDataName();
    },

    setDataName() {
      const nameGiro = this.giros.find(
        (e) => e._id === this.form.giro_sector_comercial_id
      );
      this.form.giro = nameGiro?.nombre;
      const nameActividad = this.actividadesComerciales.find(
        (e) => e._id === this.form.actividad_comercial_id
      );
      this.form.actividad_comercial = nameActividad?.nombre;
    },
  },
};
</script>
